module.exports = __webpack_public_path__ + "img/leftcalf-ecto-mesomorph-male.d4125e90.svg";